import React from 'react';

export const VolEventStartDateModal = {
  title: 'Eruption Start Date',
  body: (
    <div>
      <p>
        Where available, this date (SYYYY-MM-DD) indicates the start date of the
        eruption. When an exact start day is not available, this date defaults
        to the first day of the specified month (e.g. SYYYY-MM-01).  When only a
        start year is available, this date defaults to the first month and day
        of that year (e.g. SYYYY-01-01).
      </p>
    </div>
  ),
};
